export default function StatsRibbon() {
  const items = [
    "20 Anos de experiência",
    "Kits 100% personalizados",
    "Entrega em todo o Brasil",
    "Embalagens à prova de transporte",
    "Relatórios completos de envio",
    "Cartas, etiquetas e descritivos legais",
  ];
  const loop = [...items, ...items];

  return (
    <section
      data-testid="stats-ribbon"
      className="relative overflow-hidden py-10 border-y border-[rgba(250,250,250,0.08)]"
      style={{ backgroundColor: "#0B2E24" }}
    >
      <div className="marquee">
        {loop.map((t, i) => (
          <div key={i} className="flex items-center gap-6 shrink-0">
            <span className="w-1.5 h-1.5 rounded-full bg-[#C5A059]" />
            <span className="font-serif italic text-2xl md:text-3xl text-[#FAFAFA]/85 tracking-tight">
              {t}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
